import type { OrderPersonal } from "@repo/types";
import type {
  OrderLinesToRefund,
  OrderLineWithTotal
} from "~/hooks/queries/orders";
import { type FormattedOrderLine } from "~/utils/refund-line-formatter";

import { refundStore } from "./store";

import type { RefundStore } from ".";

function setRefundMethod(refundMethod: RefundStore["refundMethod"]) {
  refundStore.setState((state) => {
    state.refundMethod = refundMethod;
  });
}

type SetOrderLinesArgs = {
  order: Pick<
    OrderPersonal,
    | "status"
    | "id"
    | "currency"
    | "paidWithSaldoUnit"
    | "payments"
    | "payouts"
    | "discounts"
  > & {
    totalPriceUnit: number;
  } & {
    orderLines: OrderLineWithTotal[];
  };
  formattedOrderLines: FormattedOrderLine[];
  selectedOrderLines: string[];
};

function setOrderLines({
  order,
  selectedOrderLines,
  formattedOrderLines
}: SetOrderLinesArgs) {
  refundStore.setState((state) => {
    state.selectedOrderLines = selectedOrderLines.reduce(
      (acc: OrderLinesToRefund[], id) => {
        const line = formattedOrderLines.find((o) => o.id === id);
        if (!line) return acc;
        if (!line.orderLineId) return acc;

        const orderLineInOrder = order.orderLines.find(
          (o) => o.orderLineId === line.orderLineId
        );

        if (!orderLineInOrder) return acc;

        if (
          !acc.some((orderLine) => orderLine.orderLineId === line.orderLineId)
        ) {
          return [
            ...acc,
            {
              orderLineId: line.orderLineId,
              productLineId: line.productLineId,
              amount: 1,
              unitRefundAmountInclVat: line.unitRefundAmountInclVat,
              unitRefundTaxAmount: line.unitRefundTaxAmount
            }
          ];
        }
        return acc.map((orderLine) => {
          if (orderLine.orderLineId !== line.orderLineId) return orderLine;

          return {
            ...orderLine,
            productLineId: line.productLineId,
            unitRefundAmountInclVat: line.unitRefundAmountInclVat,
            unitRefundTaxAmount: line.unitRefundTaxAmount,
            amount: orderLine.amount + 1
          };
        });
      },
      []
    );
  });
}

const refundActions = {
  setRefundMethod,
  setOrderLines
};

export { refundActions };
